import { useSelector } from "react-redux"
import UseShipmentDetails from "../../../../pages/SendingParcel/apiCall/useShipmentDetails"
import { placeholder } from "../../../../util/placeholder"
import ModalLayout from "../../../modalLayout"
import Button from "../../Button"
import InputField from "../../Input"
import SearchAirportsDropDown from "../../searchAirportsDropDown"
import { useToggleThrough } from "../../../../Hooks/GlobalHook"

const ShipmentModal = () => {
  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    errors,
    touched,
    isSubmitting,
    // isLoading,
    // countries,
  } = UseShipmentDetails()

  const { handleToggleModal } = useToggleThrough()

  const { airports } = useSelector((state) => state.airports)

  //   const selectDrop = {
  //     sender_airport: airports,
  //     receiver_airport: airports,
  //     departure_airport: airports,
  //     destination_airport: airports,
  //   }

  return (
    <ModalLayout
      modalToClose={"lodgeShipment"}
      className={"w-full max-w-full md:!w-[80%] lg:!w-[60%] "}
      cancel={"top-3 right-5"}
      innerClassName={"!bg-[#f2f1f1] "}
    >
      <div className="space-y-[2rem] ">
        <h1 className="text-[1.5rem] md:text-[3rem] text-[#595757] font-semibold  ">
          Lodge Shipment
        </h1>
        <div className="w-fit">
          <p className="text-[1.4rem] text-[#0E94CD] font-normal ">
            Shipment Details
          </p>
          <div className=" h-[0.5rem] bg-[#0E94CD] rounded-[0.5rem] "></div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="grid md:grid-cols-2 gap-8 h-[65vh] overflow-auto ">
            {Object.entries(values).map(([key, value], i) => (
              <div key={i} className="flex-col bg-white rounded-[0.5rem] px-2 ">
                <label className="text-[0.8rem] text-[#2C2C2C] font-gothic ">
                  {key === "discount_code" ? "Discount Code" : placeholder(key)}
                </label>
                {key === "sender_airport" ||
                key === "receiver_airport" ||
                key === "sender_country" ||
                key === "receiver_country" ? (
                  <SearchAirportsDropDown
                    sortedAirports={airports}
                    fieldName={key}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder(key)}
                    setFieldValue={setFieldValue}
                    className={"!pt-[1.7rem] !pb-[1.1rem]"}
                  />
                ) : (
                  <InputField
                    placeholder={placeholder(key)}
                    type={
                      key === "shipment_date"
                        ? "date"
                        : key === "weight"
                        ? "number"
                        : key === "email"
                        ? "email"
                        : "text"
                    }
                    className={"bg-white !px-0 !pt-[1.7rem] !pb-[1.1rem]"}
                    value={value}
                    name={key}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    errors={errors[key]}
                    touched={touched[key]}
                    key={key}
                  />
                )}
              </div>
            ))}
            <div className="flex items-center gap-x-4 mt-[1.4rem]">
              <Button
                isSubmitting={isSubmitting}
                disabled={
                  values.departure === "" ||
                  values.destination === "" ||
                  isSubmitting
                }
                text="Proceed"
                className="text-white bg-primary-500 !w-full "
                type="submit"
              />
              <Button
                onClick={() => handleToggleModal("lodgeShipment")}
                text="Cancel"
                className="text-white bg-red-500 !w-full "
              />
            </div>
          </div>
        </form>
      </div>
    </ModalLayout>
  )
}

export default ShipmentModal
